import { type Dispatch, type SetStateAction } from 'react';
import { type ApplicationAgreementDataFragment } from '../../../../api/fragments/ApplicationAgreementData';
import { type KycFieldSpecsFragment } from '../../../../api/fragments/KYCFieldSpecs';
// eslint-disable-next-line max-len
import { type MobilityApplicationEntrypointContextDataFragment } from '../../../../api/fragments/MobilityApplicationEntrypointContextData';
import { type KYCPresetFormFields, type UploadDocumentProp } from '../../../../utilities/kycPresets';
import { type AgreementValues } from '../../../shared/CIPage/ConsentAndDeclarations/useAgreementsValues';
import { type Action, type State } from '../../StandardApplicationEntrypoint/Journey/reducer';
import { type MobilityApplicationState } from '../Journey/JourneyController';

export type CustomerDetailsProps = {
    mobility: MobilityApplicationState;
    kycPresets: KycFieldSpecsFragment[];
    endpoint: MobilityApplicationEntrypointContextDataFragment;
    token: string;
    applicationAggrements: ApplicationAgreementDataFragment[];
};

export enum FeatureKYCPageLabel {
    GiftVoucher = 'giftVoucher',
    Default = 'default',
}

export type ApplicantKYCProps = {
    state?: State<MobilityApplicationState>;
    dispatch?: Dispatch<Action<MobilityApplicationState>>;
    endpoint: MobilityApplicationEntrypointContextDataFragment;
    handleEndSession?: () => void;
    mobilityKycPreset?: KycFieldSpecsFragment[];
    setIsCorporate?: Dispatch<SetStateAction<boolean>>;
    isCorporate?: boolean;
    showTabs: boolean;
    setPrefill?: Dispatch<SetStateAction<boolean>>;
};

export type ApplicantKYCInnerProps = ApplicantKYCProps & {
    showResetButton?: boolean;
} & UploadDocumentProp;

export type MobilityApplicantFormValues = {
    fields: KYCPresetFormFields;
};

export type MobilityKYCJourneyValues = {
    agreements: AgreementValues;
    customer: MobilityApplicantFormValues;
    isCorporateCustomer: boolean;
    hasGuarantor: boolean;
    prefix?: string;
    prefill: boolean;
};
